// Modal.js
import React from 'react';
import ReactDOM from 'react-dom';
import Button from "@mui/material/Button";

const Modal = ({ isOpen, children, onClose }) => {
    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <Button onClick={onClose} style={styles.closeButton}>X</Button>
                {children}
            </div>
        </div>,
        document.getElementById('modal-root')
);
};

const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    modal: {
        background: '#fff',
        padding: '2rem',
        borderRadius: '4px',
        position: 'relative'
    },
    closeButton: {
        position: 'absolute',
        top: '0.5rem',
        right: '0rem',
        color: "#000"
    }
};

export default Modal;
